import { useTranslate } from '../translate/I18n';
import { useMemo } from 'react';
import { logMessage } from '../utils/distantLogger';

export const useNumber = () => {
    const { i18n } = useTranslate();
    return useMemo(() => {
        return {
            formatNumber: function (number) {
                switch (i18n.language.toLowerCase()) {
                    case 'fr':
                        return number.toLocaleString('fr-FR');
                    case 'fr-ch':
                        return number.toLocaleString('fr-CH');
                    case 'fr-lu':
                        return number.toLocaleString('fr-LU');
                    case 'nl':
                        return number.toLocaleString('nl-BE');
                    case 'en':
                        return number.toLocaleString('en-GB');
                    case 'en-lu':
                        return number.toLocaleString('en-LU');
                    default:
                        logMessage(
                            `warning i18n.language is ${i18n.language}, but should be 'fr', 'nl', 'fr-ch', 'fr-lu', 'en-lu' or 'en' (which is the fallback)`,
                            'warning'
                        );
                        return number.toLocaleString('en-GB');
                }
            }
        };
    }, [i18n.language]);
};